/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, percent: NonNullable<unknown> }} Notifications_Message_Body_DeltaInputs */

const he_notifications_message_body_delta = /** @type {(inputs: Notifications_Message_Body_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ירד ב-${i?.amount} (${i?.percent}%)`)
};

const en_notifications_message_body_delta = /** @type {(inputs: Notifications_Message_Body_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`down ${i?.amount} (${i?.percent}%)`)
};

/**
* | output |
* | --- |
* | "down {amount} ({percent}%)" |
*
* @param {Notifications_Message_Body_DeltaInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_body_delta = /** @type {((inputs: Notifications_Message_Body_DeltaInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Body_DeltaInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_body_delta(inputs)
	return en_notifications_message_body_delta(inputs)
});